class MobileStickyCheckout extends HTMLElement {
  connectedCallback() {
    this.countEl = this.querySelector('.mobile-sticky-checkout__count');
    this.totalEl = this.querySelector('.mobile-sticky-checkout__total');

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.updateFromCart();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  updateFromCart() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        this.classList.toggle('is-empty', cart.item_count === 0);
        if (this.countEl) {
          this.countEl.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
        }
        if (this.totalEl) {
          this.totalEl.textContent = this.formatMoney(cart.total_price, cart.currency);
        }
      })
      .catch(() => {});
  }

  formatMoney(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }
}

customElements.define('mobile-sticky-checkout', MobileStickyCheckout);
